import React, { useState, useEffect } from "react";
import { defaultUserImg, LogoImg } from "../Constants/Images";
import { Link, useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { Mic, X } from "lucide-react";
import useAuth from "../Hooks/useAuth";
import CustomButton from "./Button";
import { SearchSpaceAgent } from "./Agent/SearchAgent";
import { Dropdown } from "react-bootstrap";
import { logoutAction } from "../Services/Store/Actions/AuthActions";
import { useDispatch } from "react-redux";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isLoggedIn, user } = useAuth();
  const [isAgentOpen, setIsAgentOpen] = useState(false);

  const userImg = user && user.image ? user.image : defaultUserImg;

  const handleOpenAgent = () => {
    setIsAgentOpen(true);
  };

  const handleCloseAgent = () => {
    setIsAgentOpen(false);
  };

  // Handle ESC key to close popup
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isAgentOpen) {
        handleCloseAgent();
      }
    };

    if (isAgentOpen) {
      document.addEventListener("keydown", handleEscKey);
      // Prevent body scroll when popup is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey);
      document.body.style.overflow = "unset";
    };
  }, [isAgentOpen]);

  return (
    <>
      <div className="site-header">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-4">
              <div className="header-logo">
                <Link to="/" title="Spacii Delivery">
                  <img src={LogoImg} alt="" />
                </Link>
              </div>
            </div>

            <div className="col-md-4 col-sm-4">
              <div className="header-menu">
                <ul>
                  <li>
                    <Link to="/search">Browse Spaces </Link>
                  </li>

                  <li>
                    <Link to="/user/venues" title="List Your Spacii">
                      List Your Spacii
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-4 col-sm-4">
              <div className="header-auth-links">
                {isLoggedIn && (
                  <button
                    onClick={handleOpenAgent}
                    className="ai-agent-btn"
                    title="Space Search Agent"
                  >
                    <Mic size={20} color="white" />
                    <span className="small-dot" />
                  </button>
                )}

                {!isLoggedIn && (
                  <ul>
                    <li>
                      <Link to="/login">
                        <FontAwesomeIcon
                          icon={faGlobe}
                          size={"1x"}
                          color="#000000"
                          style={{ marginRight: 5 }}
                        />{" "}
                        Log in
                      </Link>
                    </li>

                    <li>
                      <Link to="/signup" className="sign-up">
                        Sign up
                      </Link>
                    </li>
                  </ul>
                )}

                {isLoggedIn && (
                  <>
                    <Dropdown>
                      <Dropdown.Toggle>
                        <div className="user-infos">
                          <img src={userImg} alt="" />

                          <div className="user-names">
                            <div className="user-name">{user && user.name}</div>
                            <div className="user-email">
                              {user && user.email}
                            </div>
                          </div>

                          <FontAwesomeIcon icon={faChevronDown} />
                        </div>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item href={`/${user.type}/profile`}>
                          Profile
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#"
                          onClick={() => logoutAction(dispatch)}
                        >
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* <CustomButton
                      isLoading={false}
                      type="button"
                      title={user && user.name !== "" && `${user.name} `}
                      onClick={() => navigate("/user/profile")}
                    >
                      <FontAwesomeIcon icon={faChevronDown} />
                    </CustomButton> */}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {isAgentOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            backdropFilter: "blur(10px)",
            animation: "fadeIn 0.3s ease-out",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "24px",
          }}
        >
          <button
            onClick={handleCloseAgent}
            style={{
              position: "absolute",
              top: "24px",
              right: "24px",
              zIndex: 10000,
              background: "rgba(255, 255, 255, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "50%",
              width: "48px",
              height: "48px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.3s ease",
              backdropFilter: "blur(10px)",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
              e.currentTarget.style.transform = "scale(1.1) rotate(90deg)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
              e.currentTarget.style.transform = "scale(1) rotate(0deg)";
            }}
            title="Close Agent (ESC)"
          >
            <X size={24} color="black" />
          </button>
          <div
            style={{ maxWidth: "1400px", width: "100%", textAlign: "center" }}
          >
            <div
              style={{
                marginBottom: "32px",
                animation: "slideDown 0.4s ease-out",
              }}
            >
              <h1
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "rgb(255, 83, 73)",
                  marginBottom: "8px",
                }}
              >
                Meet Milo
              </h1>
              <p
                style={{
                  color: "#a1a2a3",
                  fontSize: "1.125rem",
                }}
              >
                Tell me about your occassion
              </p>
            </div>

            <div style={{ animation: "slideUp 0.4s ease-out 0.1s both" }}>
              <SearchSpaceAgent
                autoStart={true}
                onDisconnect={handleCloseAgent}
              />
            </div>
            <div
              style={{
                marginTop: "32px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                color: "rgba(12, 12, 12, 0.8)",
                fontSize: "0.875rem",
              }}
            >
              Press{" "}
              <kbd
                style={{
                  padding: "4px 8px",
                  background: "rgba(0, 0, 0, 0.3)",
                  borderRadius: "4px",
                  fontFamily: "monospace",
                }}
              >
                ESC
              </kbd>{" "}
              to close
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }

        /* Custom scrollbar for agent popup */
        div[style*="position: fixed"]::-webkit-scrollbar {
          width: 8px;
        }

        div[style*="position: fixed"]::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
        }

        div[style*="position: fixed"]::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 4px;
        }

        div[style*="position: fixed"]::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.5);
        }
      `}</style>
    </>
  );
};

export default Header;
